import { ArrowForwardIos, CallSplit, ContentCopy, Delete } from "@mui/icons-material";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  const typeCondition = (value) => {
    if(value === 1) return '=='
    if(value === 2) return '>='
    if(value === 3) return '<='
    if(value === 4) return '<'
    if(value === 5) return '>'
  }

  return (
    <div
      style={{
        backgroundColor: "#FFFDF7",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        border: '2px solid rgba(245, 158, 11, 0.3)',
        minWidth: "220px",
        transition: "all 0.2s ease",
        position: "relative"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(45deg, #f59e0b, #d97706)",
          width: "20px",
          height: "20px",
          top: "50%",
          left: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none',
            transform: "rotate(180deg)"
          }}
        />
      </Handle>

      <div
        style={{
          position: "absolute",
          right: "12px",
          top: "12px",
          display: "flex",
          gap: "8px"
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#f59e0b"
            }
          }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ 
            width: "18px", 
            height: "18px", 
            color: "#94a3b8",
            cursor: "pointer",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#ef4444"
            }
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "12px"
        }}
      >
        <CallSplit
          sx={{
            width: "20px",
            height: "20px",
            marginRight: "8px",
            color: "#f59e0b"
          }}
        />
        <div style={{ 
          color: "#1a1a1a", 
          fontSize: "16px",
          fontWeight: "600",
          letterSpacing: "0.01em"
        }}>
          Condição
        </div>
      </div>

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      }}>
        <div style={{ 
          color: "#374151", 
          fontSize: "13px",
          lineHeight: "1.5",
          padding: "8px",
          backgroundColor: "#fef3c7",
          borderRadius: "6px",
          border: "1px solid #fcd34d"
        }}>
          <div style={{ fontWeight: "500", marginBottom: "4px" }}>Campo:</div>
          {data.key}
        </div>

        <div style={{ 
          color: "#374151", 
          fontSize: "13px",
          lineHeight: "1.5",
          padding: "8px",
          backgroundColor: "#fef3c7",
          borderRadius: "6px",
          border: "1px solid #fcd34d"
        }}>
          <div style={{ fontWeight: "500", marginBottom: "4px" }}>Operador:</div>
          {typeCondition(data.condition)}
        </div>

        <div style={{ 
          color: "#374151", 
          fontSize: "13px",
          lineHeight: "1.5",
          padding: "8px",
          backgroundColor: "#fef3c7",
          borderRadius: "6px",
          border: "1px solid #fcd34d"
        }}>
          <div style={{ fontWeight: "500", marginBottom: "4px" }}>Valor:</div>
          {data.value}
        </div>
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(45deg, #f59e0b, #d97706)",
          width: "20px",
          height: "20px",
          top: "30%",
          right: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>

      <Handle
        type="source"
        position="right"
        id="b"
        style={{
          background: "linear-gradient(45deg, #f59e0b, #d97706)",
          width: "20px",
          height: "20px",
          top: "70%",
          right: "-10px",
          cursor: 'pointer',
          border: "2px solid #ffffff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "12px",
            height: "12px",
            marginLeft: "2px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
    </div>
  );
});